export { HighlightableElementProvider } from "./context";
export { default as HighlightableElement } from "./HighlightableElement";
export { default as HighlightOverlay } from "./HighlightOverlay";
export { default as FadeDuringHighlight } from "./FadeDuringHighlight";
